import { render, staticRenderFns } from "./TwitchAuthRedirectView.vue?vue&type=template&id=54484254"
import script from "./TwitchAuthRedirectView.vue?vue&type=script&lang=js"
export * from "./TwitchAuthRedirectView.vue?vue&type=script&lang=js"
import style0 from "./TwitchAuthRedirectView.vue?vue&type=style&index=0&id=54484254&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports